import PropTypes from 'prop-types';
import React from 'react';
import ClientLogo from '../client-logo';

var defaultRenderLogo = function defaultRenderLogo(logo) {
  return logo;
};

var Header = function Header(_ref) {
  var logoUrl = _ref.logoUrl,
      className = _ref.className,
      children = _ref.children,
      _ref$renderLogo = _ref.renderLogo,
      renderLogo = _ref$renderLogo === undefined ? defaultRenderLogo : _ref$renderLogo;
  return React.createElement(
    'div',
    { className: 'csp-header__wrapper ' + className },
    React.createElement(
      'h1',
      { className: 'csp-header__title' },
      renderLogo(React.createElement(ClientLogo, { logoUrl: logoUrl, size: 'medium' }))
    ),
    children
  );
};

Header.propTypes = process.env.NODE_ENV !== "production" ? {
  logoUrl: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  renderLogo: PropTypes.func
} : {};

export default Header;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/es/components/header/Header.js
// module id = null
// module chunks = 